import andon from './andon';

export default {
	andonPage: andon
}
